<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>Service Type</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"><i data-feather="home"></i></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item active">Service Type</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid list-products">
          <div class="row">
            <!-- Create New -->
            <div class="col-sm-12 col-lg-12" v-if="isCreate">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>Add New Service</h5>
                </div>
                <div class="card-body">
                  <!-- <form> -->
                  <div class="row g-3">
                    <div class="col-md-3">
                      <label class="form-label" for="title">Title</label>
                      <input v-model="title" class="form-control" id="color" type="text" placeholder="Enter Title"
                        aria-describedby="inputGroupPrepend" required />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label" for="title">Billing period</label>
                      <select v-model="billing_period" class="form-control">
                        <option value="">Select period</option>
                        <option value="1">One Time</option>
                        <option value="2">Monthly</option>
                        <option value="3">Yearly</option>
                      </select>
                    </div>

                  </div>
                  <button class="btn btn-primary" type="submit" @click="addNew">
                    Add
                  </button>
                  <!-- </form> -->
                </div>
              </div>
            </div>
            <!-- Update -->
            <div class="col-sm-12 col-lg-12" v-if="!isCreate">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>Update Service</h5>
                </div>
                <div class="card-body">
                  <!-- <form> -->
                  <div class="row g-3">
                    <div class="col-md-3">
                      <label class="form-label" for="title">Name</label>
                      <input v-model="update.title" class="form-control" id="color" type="text"
                        placeholder="Enter Area Name" aria-describedby="inputGroupPrepend" required />
                    </div>
                    <div class="col-md-3">
                      <label class="form-label" for="title">Billing period</label>
                      <select v-model="update.billing_period" class="form-control">
                        <option value="">Select period</option>
                        <option value="1">One Time</option>
                        <option value="2">Monthly</option>
                        <option value="3">Yearly</option>
                      </select>
                    </div>
                    <!--   <div class="col-md-3">
                      <label class="form-label" for="status">Price</label>
                      <input v-model="update.price" class="form-control" id="status" type="text"
                        placeholder="Enter Price" aria-describedby="inputGroupPrepend" required />
                    </div> -->
                  </div>
                  <button class="btn btn-primary" type="submit" @click="updateTypeSubmit">
                    Update
                  </button>
                  <button class="btn btn-danger" type="submit" @click="cancelUpdate">
                    Cancel
                  </button>
                  <!-- </form> -->
                </div>
              </div>
            </div>
            <!-- Data table -->
            <div class="col-sm-12 col-lg-12">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>List</h5>
                  <span>Service Type</span>
                </div>
                <div class="card-body">
                  <div class="table-responsive product-tabl">
                    <table class="display w-100" id="serviceListTBL">
                      <thead>
                        <tr align="center">
                          <th>#</th>
                          <th>Title</th>
                          <th>Billing Period</th>
                          <!-- <th>Price</th> -->
                          <th>Active Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr align="center" v-for="(item, index) in serviceList" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.title }}</td>
                          <td>{{ item.billing_period === 1 ? 'Daily' : item.billing_period === 2 ? 'Monthly' : 'Yearly' }}
                          </td>
                          <!-- <td>{{ item.actual_price }}</td> -->
                          <td>
                            <div class="media-body switch-sm" v-if="item.active_status === 1"
                              @click.prevent="changeStatus(item.id)">
                              <label class="switch">
                                <input type="checkbox" checked /><span class="switch-state"></span>
                              </label>
                            </div>
                            <div class="media-body switch-sm" v-if="item.active_status === 0"
                              @click.prevent="changeStatus(item.id)">
                              <label class="switch">
                                <input type="checkbox" /><span class="switch-state"></span>
                              </label>
                            </div>
                          </td>
                          <td>
                            <button class="btn btn-danger btn-xs" type="button"
                              data-original-title="btn btn-danger btn-xs" title="" @click.prevent="deleteType(item.id)">
                              Delete
                            </button>
                            <button class="btn btn-primary btn-xs" type="button"
                              data-original-title="btn btn-danger btn-xs" title="" @click.prevent="updateType(item)">
                              Edit
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Container-fluid starts-->
      </div>
    </div>
  </div>
</template>

<script>
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net-dt/js/dataTables.dataTables';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import service_typeAPI from '../../../services/service_type.API.js';

import $ from 'jquery';

export default {
  name: 'serviceList',
  components: {},
  data() {
    return {
      title: '',
      price: '',
      serviceList: [],
      districtList: [],
      isCreate: true,
      billing_period: '',
      update: {
        id: '',
        title: '',
        // active_status: '',
      },
      selectedDistrict: null,
    };
  },
  methods: {
    // district list
    getList() {
      service_typeAPI.getList().then(
        response => {
          this.serviceList = response.data.data;
          console.log(response.data.data);
        },
        err => {
          if (err.response.data.success === false) {
            this.serviceList = [];
          }
        },
      );
    },

    // addNew
    addNew() {
      //   console.log(this.title, this.status);
      if (this.title == '') {
        this.$moshaToast('Please enter Area title', {
          type: 'danger',
          position: 'top-right',
          showIcon: true,
        });
      } else {
        let data = {
          actual_price: 0,
          title: this.title,
          billing_period: Number(this.billing_period),
        };
        service_typeAPI
          .createServiceType(data)
          .then(response => {
            this.$moshaToast(response.data.message, {
              type: 'success',
              position: 'top-right',
              showIcon: true,
            });
            // get all connection type
            service_typeAPI.getList().then(response => {
              this.serviceList = response.data.data;
            });
            this.title = '';
            this.price = '';
            this.billing_period = ''
          })
          .catch(error => {
            // console.log(error.response.data.success);
            if (error.response.data.success === false) {
              this.$moshaToast(error.response.data.message, {
                type: 'danger',
                position: 'top-right',
                showIcon: true,
              });
            }
          });
      }
    },

    // delete
    deleteType(id) {
      if (id) {

        this.$swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.isConfirmed) {
            service_typeAPI.deleteServiceType(id).then(response => {
              this.$moshaToast(response.data.message, {
                type: 'success',
                position: 'top-right',
                showIcon: true,
              });
              // get all connection type
              service_typeAPI.getList().then(response => {
                this.serviceList = response.data.data;
              });
            });
          }
        })

      } else {
        this.$moshaToast('Please select service type', {
          type: 'danger',
          position: 'top-right',
          showIcon: true,
        });
      }
    },

    // change status
    changeStatus(id) {
      if (id) {
        service_typeAPI.changeStatus(id).then(response => {
          this.$moshaToast(response.data.message, {
            type: 'success',
            position: 'top-right',
            showIcon: true,
          });
          // get all connection type
          service_typeAPI.getList().then(response => {
            this.serviceList = response.data.data;
          });
        });
      } else {
        this.$moshaToast('Please select connection type', {
          type: 'danger',
          position: 'top-right',
          showIcon: true,
        });
      }
    },

    // update
    updateType(item) {
      this.isCreate = false;
      //   this.title = item.title;
      //   this.status = item.status === 1 ? true : false;
      this.id = item.id;
      // console.log(this.update);
      this.update.id = item.id;
      this.update.title = item.title;
      // this.update.price = item.actual_price;
      this.update.billing_period = item.billing_period.toString();
    },

    // cancelUpdate
    cancelUpdate() {
      this.isCreate = true;
      this.update.id = '';
      this.update.title = '';
      this.selectedDistrict = '';
      this.update.billing_period = '';
    },

    // update submit
    updateTypeSubmit() {
      if (this.update.title == '') {
        this.$moshaToast('Please enter area title', {
          type: 'danger',
          position: 'top-right',
          showIcon: true,
        });
      } else if (this.update.price == '') {
        this.$moshaToast('Please enter price', {
          type: 'danger',
          position: 'top-right',
          showIcon: true,
        });
      } else {
        // console.log(this.update);
        let data = {
          id: this.update.id,
          title: this.update.title,
          actual_price: this.update.price,
          billing_period: Number(this.update.billing_period),

        };
        service_typeAPI
          .updateServiceType(data)
          .then(response => {
            this.$moshaToast(response.data.message, {
              type: 'success',
              position: 'top-right',
              showIcon: true,
            });
            // get all connection type
            service_typeAPI.getList().then(response => {
              this.serviceList = response.data.data;
            });
            this.isCreate = true;
            this.update.id = '';
            this.update.title = '';
            this.selectedDistrict = '';
          })
          .catch(error => {
            // console.log(error.response.data.success);
            if (error.response.data.success === false) {
              this.$moshaToast(error.response.data.message, {
                type: 'danger',
                position: 'top-right',
                showIcon: true,
              });
            }
          });
      }
    },
  },
  mounted() {
    //   list
    service_typeAPI.getList().then(response => {
      this.serviceList = response.data.data;
      setTimeout(() => {
        $('#serviceListTBL').DataTable({
          lengthMenu: [
            [10, 25, 50, -1],
            [10, 25, 50, 'All'],
          ],
          pageLength: 10,
          info: false,
          targets: 'no-sort',
          bSort: false,
          order: [],
          bFilter: true,
          bInfo: false,
          //   bLengthChange: false,
          bDestroy: true,
        });
      });
    });
  },
};
</script>

<style scoped>
.btn {
  margin: 5px;
}

th {
  text-align: center !important;
}
</style>
